import { createApp } from 'vue';
import App from './Bookings.vue';
import '../../../registerServiceWorker';
import store from '../../../store';
import mitt from 'mitt';
const emitter = mitt();

import "primeflex/primeflex.css";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";


import PrimeVue from 'primevue/config';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from 'primevue/columngroup'; 
import Button from "primevue/button";
import Dialog from 'primevue/dialog';
import Menu from 'primevue/menu';

import { VueCookieNext } from 'vue-cookie-next';

let app = createApp(App);

app.config.globalProperties.emitter = emitter;
app.use(PrimeVue);
app.component('Dialog', Dialog);
app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Button", Button);
app.component("Menu", Menu);
app.use(store);
app.use(VueCookieNext);
app.mount('#app');
